<template>
  <div>
    <TabsInfo class="tabsinfo" />
  </div>
</template>

<script>
import TabsInfo from "@/components/clients/TabsInfo"
export default {
  name: "ClientInfo",
  components: {
    TabsInfo,
  },
}
</script>

<style scoped>
.tabsinfo {
  min-height: 570px;
}
.buttonsholder {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 0 auto;
}
</style>
